export { default } from './LandingHeader.container'



// WEBPACK FOOTER //
// ./src/components/LandingHeader/index.js